import { useState } from "react";
import { useWeb3 } from "../context/Web3Context";
import { useContract } from "./useContract";

export function useUserData() {
  const { account } = useWeb3();
  const contracts = useContract();
  const [userId, setUserId] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  async function fetchUserData() {
    if (!contracts || !account) return null;
    setLoading(true);
    try {
      const uid = await contracts.data.addrToId(account);
      const uidNum = uid.toNumber();
      setUserId(uidNum);

      if (uidNum === 0) {
        setUserInfo(null);
        return null;
      }

      const info = await contracts.data.getUserInfo(uidNum);
      const parsed = {
        wallet: info.wallet,
        id: info.id.toNumber(),
        referrerId: info.referrerId.toNumber(),
        name: info.name,
        totalInvested: info.totalInvested,
        totalEarned: info.totalEarned,
        totalClaimed: info.totalClaimed,
        claimable: info.claimable,
        directRefCount: info.directRefCount.toNumber(),
        active: info.active,
        isBlacklisted: info.isBL,
      };
      setUserInfo(parsed);
      return parsed;
    } catch (err) {
      console.error("fetchUserData error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  }

  return { userId, userInfo, loading, fetchUserData };
}
